import { Component, OnInit } from '@angular/core'; 
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router'; 
import { SalesDashboardComponent } from '../Sales/sales-dashboard/sales-dashboard.component';
import { StockDashboardComponent } from '../stock-dashboard/stock-dashboard.component';
import { AccountsDashboardComponent } from '../Profit-Loss/accounts-dashboard/accounts-dashboard.component';
import { StaffDashboardComponent } from '../staff-dashboard/staff-dashboard.component';

@Component({
  selector: 'app-admin-dashboard',
  standalone: true, 
  imports: [CommonModule, SalesDashboardComponent, StockDashboardComponent, AccountsDashboardComponent, StaffDashboardComponent],
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css']
})
export class AdminDashboardComponent implements OnInit { 
  
  currentTab: string = 'sales'; // Default tab


  constructor(private route: ActivatedRoute) {}


  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['tab']) {
        this.currentTab = params['tab']; 
      }
    });
  }

  switchTab(tab: string) {
    this.currentTab = tab;
  }
}